const $ = jQuery.noConflict();

class Slider {
    constructor(sel, infinite = true, fade = false, num = 1, slideSpeed = 600, variableWidth = false, centerMode = false, variableWidthMobile = false, centerModeMobile = false, dots = false, arrows = true, appendDots = false, customPaging = false) {
        this.selector = sel;
        this.infinite = infinite;
        this.fade = fade;
        this.num = num;
        this.slideSpeed = slideSpeed;
        this.variableWidth = variableWidth;
        this.centerMode = centerMode;
        this.variableWidthMobile = variableWidthMobile;
        this.centerModeMobile = centerModeMobile;
        this.outerEdgeLimit = this.infinite;
        this.dots = dots;
        this.arrows = arrows;
        this.appendDots = appendDots;
        this.customPaging = customPaging;
    }

    init() {
        const {
            infinite,
            fade,
            num,
            slideSpeed,
            variableWidth,
            centerMode,
            variableWidthMobile,
            centerModeMobile,
            outerEdgeLimit,
            arrows,
            dots,
            customPaging,
            appendDots
        } = this;

        function slideSettings() {
            const _that = $(this);
            // Set max-width to slider captions
            _that.on('setPosition', () => {
                _that.find('figcaption').each((i, item) => {
                    const caption = $(item);
                    const width = caption.prev('img').width();

                    caption.css('max-width', width > 0 ? `${width}px` : '');
                });
            });

            // Init slider
            _that.slick({
                dots,
                appendDots,
                arrows,
                slidesToShow: num,
                slidesToScroll: 1,
                rows: 0,
                outerEdgeLimit,
                infinite,
                variableWidth,
                fade,
                centerMode,
                pauseOnHover: false,
                speed: slideSpeed,
                customPaging,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        variableWidth: variableWidthMobile,
                        centerMode: centerModeMobile
                    }
                }]
            });

            // Custom arrows for wipe animation
            if (_that.hasClass('bg-slider__slider') || _that.hasClass('lightbox-gallery__slider')) {
                const parent = _that.parent();

                parent.find('.slick-prev').on('click', (e) => {
                    e.preventDefault();

                    _that.slick('slickPrev');
                });

                parent.find('.slick-next').on('click', (e) => {
                    e.preventDefault();
                    parent.find('.slick-arrow').attr("disabled", true);

                    const current = _that.find('.slick-current');
                    current.addClass('switch-out');

                    setTimeout(() => {
                        _that.slick('slickNext');
                        setTimeout(() => {
                            current.removeClass('switch-out');
                            parent.find('.slick-arrow').attr("disabled", false);
                        }, slideSpeed);
                    }, slideSpeed);
                });
            }
        }

        $(this.selector).each(slideSettings);
    }
}

const customControlPrograms = () => {
    $('.block-programs-slider__nav span').each((i, e) => {
        $(e).on('click', () => {
            if ( window.matchMedia('(max-width:992px)').matches ) {
                $('.block-programs-slider__wrapper').slick('slickNext');
            }
        });
    });
}

const SimpleSlider = new Slider('.bg-slider__slider', true, false, 1, 600, true, false, true, false, false, false);
const LightboxSlider = new Slider('.lightbox-gallery__slider', true, false, 1, 600, true, false, true, false, false, false);
const ProgramsSlider = new Slider('.block-programs-slider__wrapper', true, true, 1, 600, false, false, false, false, true, false, '.block-programs-slider__nav', (slider, i) => {
    const next = slider.$slides.length === i + 1 ? slider.$slides[0].dataset.title : slider.$slides[i+1].dataset.title;
    return `<span role="tab" data-next="${next}">${slider.$slides[i].dataset.title}</span>`;
});

export { SimpleSlider, LightboxSlider, ProgramsSlider, customControlPrograms };
